import React from 'react'
import axios from '~/data/http/axios';
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import CheckBox from '~/Common-Objects/UI/Forms/CheckBox/CheckBox'
import Column from '~/Common-Objects/Grids/Column/Column'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import { connect } from 'react-redux';
import * as siteMaster from '~/data/actions/siteActions'; //now we can use user actions here
import i18n from '~/i18n';


//CONNECT TO STORE
@connect((store) => {
    return { user: store.user, permissionStore: store.permission, siteMaster: store.siteMaster }
})

export default class SalesMateBindFields extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            appData: {},
            isLoaded: false,
            fields: []
        };

        this.getApp = this.getApp.bind(this);
        this.getFields = this.getFields.bind(this);
        this.toggleField = this.toggleField.bind(this);
        this.save = this.save.bind(this);

    }

    componentDidMount() {
        this.getApp();
    }

    getApp() {
        var self = this;
        axios.get("/application/account/app/38").then(_theApp => {
            self.setState({ appData: _theApp.data.Application }, this.getFields)
        })
    }

    getFields() {
        axios.get('/application/salesmate/fields').then(response => {
            this.setState({
                fields: response.data.Fields,
                isLoaded: true
            })
        }).catch(err => {
            // something has gone wrong, allow them to disconnect and retry
            this.props.history.push('/cp/company/integrations/apps/salesmate/error')
        })
    }

    toggleField(field) {
        var appData = this.state.appData
        appData.appSettings.setupFinished = false
        var fields = appData.appSettings.fields || {}
        if (fields[field.fieldName]) {
            delete fields[field.fieldName]
        } else {
            fields[field.fieldName] = { mergeTag: field.mergeTag, fieldDesc: field.displayName, name: field.fieldName }
        }
        appData.appSettings.fields = fields
        this.setState({
            appData
        })
    }

    save() {
        axios.put('/application/account/' + this.state.appData.id, this.state.appData).then(() => {
            if (this.props.finish) {
                this.props.finish()
            } else {
                this.props.history.push('/cp/company/integrations/apps/salesmate')
            }
        }).catch(err => {
        })
    }



    render() {

        if (this.state.isLoaded == false) return <div className='center-xs'>
            <h4 className='mar-b25'>Reading data from Salesmate, please wait</h4>
            <LoadingIcons iconType="2" />
        </div>
        var fieldMapping = this.state.appData.appSettings.fields || {}

        return <div>
            <Row>
                <Column xs={12} margin={0}>
                    <Paper>
                        <Row>
                            <Column xs={12} margin={0}>
                                <h4 className="mar-b25">Fields to Import</h4>
                                <div className='mar-b10'>Please select the fields you would like to Synchronise with Transpond from Salesmate.</div>
                                <Row className="mar-b30">
                                    <Column xs={12} sm={6} md={4} margin={0}>
                                        <CheckBox checked={true} >Email Address</CheckBox>
                                    </Column>
                                    {this.state.fields.map((field, index) => {
                                        var checked = !!fieldMapping[field.fieldName]
                                        return <Column xs={12} sm={6} md={4} margin={0} key={index} className="mar-b5">
                                            <CheckBox checked={checked} onChange={() => this.toggleField(field)}>{field.displayName}</CheckBox>
                                        </Column>
                                    })}
                                </Row>
                            </Column>
                            <Column xs={12} className="end-xs">
                                <Button text="Save and Continue" onClick={this.save} />
                            </Column>
                        </Row>
                    </Paper>
                </Column>



            </Row>

        </div >

    };


};


